import React from 'react'
// import { Button, Checkbox, Col, Divider, Form, Icon, Input, Modal, Row, Select, Tabs } from 'antd';
import styled from '@src/styled-components';

import I18n from '@src/i18n';
// import SearchComponent from '@components/Default/Search/SearchComponent';
import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import TableComponent from '@components/TableComponent';
import PermissionsModal from '@components/Permissions/PermissionsModal'
import GroupService from '@services/graphQL/graphQLGroup'
import NotificationComponent from '@src/helpers/_showNotifications';
import verifyItemPermission from '@helpers/verifyItemPermission'

const groupService = new GroupService()

class GroupManager extends React.Component<any, any> {
  constructor (props: any) {
    super(props)
    this.state = {
      showPermissionsModal: false,
      currentGroup: null
    }
  }

  async deleteUserGroup (id: number) {
    try {
      await groupService.deleteUserGroup(id)
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("permissions.form.delete.success"))
      this.props.onLoadGroups()
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("permissions.form.delete.error"), e);
    }
  }

  render() {
    const groupsColumns = [{
      title: 'table.profile.name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'table.actions',
      dataIndex: 'action',
      key: 'action'
    }]

    const { showPermissionsModal, currentGroup } = this.state
    const { groups, loadingGroups } = this.props

    return (<>
      <Toolbar>
        <ToolbarItem>
          {verifyItemPermission(null, 'can_create_groups', null, true) && <RegisterBtnComponent
            onClick={() => this.setState({ currentGroup: { id: null, name: '' }, showPermissionsModal: !this.state.showPermissionsModal })}
            buttonText={I18n.l('common.register') + " " + I18n.l('label.group')}
          />}
        </ToolbarItem>

        {/* <ToolbarItem>
          <SearchComponent
            onSubmit={(e: any) => e}
            placeholder='form.placeholders.groupSearch'
            defaultValue={''}
            buttonText='form.buttons.search'
          />
        </ToolbarItem> */}
      </Toolbar>

      <div className="goepik-component-tablesize">
        {loadingGroups && <p>Loading groups...</p>}
        {!loadingGroups && <TableComponent
          columns={groupsColumns}
          data={groups}
          noPagination={true}
          showConfirmationModal={false}
          onDelete={(e: any) => this.deleteUserGroup(e)}
          onEdit={(e: any) => this.setState({ currentGroup: e, showPermissionsModal: !this.state.showPermissionsModal })}
          editPermission="can_edit_groups"
          deletePermission="can_delete_groups"
          pillar="LI"
        />}
      </div>
      
      {/* <Button
        className="loading-more"
        type="primary"
        loading={this.state.iconLoading}
        onClick={(e: any) => e}
        size='large'
        ghost
      >
        {I18n.l('common.seeMore')}
      </Button> */}
      
      {!loadingGroups && groups.length === 0 && <p>{I18n.l('common.noResult')}</p>}

      {showPermissionsModal && <PermissionsModal
        visible={showPermissionsModal}
        onToggleModal={() => this.setState({ showPermissionsModal: !showPermissionsModal })}
        currentGroup={currentGroup}
        onLoadGroups={this.props.onLoadGroups}
      />}
    </>)
  }
}

const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
`;

const ToolbarItem = styled.div`
  flex: 1;
  margin-left: 50px;

  &:first-of-type {
    flex: 0;
    margin-left: 0;
  }
`;

export default GroupManager
